import { useCallback, useMemo } from 'react';

import fromPairs from 'lodash/fromPairs';

import { metricActionsMap } from 'scenes/Trackers/Tracker/components/TrackerDataTable/components/EditRow/constants';

export const useBulkActions = (columns) => {
  const editableCols = useMemo(
    () => columns.filter(({ editable }) => editable),
    [columns]
  );
  const colActionMap = useMemo(() => {
    const pairs = editableCols
      .map(({ name }) => {
        return [metricActionsMap[name], name];
      })
      .filter(([v]) => v !== undefined);

    return fromPairs(pairs);
  }, [editableCols]);

  const bulkActions = Object.keys(colActionMap);

  const getBulkCol = useCallback(
    (bulkAction) => colActionMap[bulkAction],
    [colActionMap]
  );

  return [bulkActions, getBulkCol];
};
